import request from '@/utils/request'

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/app/personal/getInfo',
    method: 'get'
  })
}

// 获取量表列表
export function getMyScaleRecord(params) {
  return request({
    url: '/app/personal/getMyScaleRecord'+params,
    method: 'post'
  })
}

// 修改个人信息
export function updateInfo(params) {
  return request({
    url: '/app/personal/updateInfo'+params,
    method: 'post'
  })
}


// 修改密码
export function updatePwd(params) {
  return request({
    url: '/app/personal/updatePwd'+params,
    method: 'post'
  })
}

//获取量表详情
export function getScaleDetail(params) {
    return request({
        url: '/app/index/getScaleDetail' + params,
        method: 'post'
    })
}

export function getReportAuth() {
    return request({
        url: '/app/ass/getReportAuth',
        method: 'post'
    })
}


export function getScreenInfo() {
    return request({
        url: '/getScreenInfo',
        method: 'get',
		headers: {
		  isToken: false
		}
    })
}



